import React from 'react';
import { isIos } from '../../../../utils/commonFunctions';

const PermitMobileInstruction = () => {
    const isIosDevice = isIos()
    return (
        <span>
                <h3 className="mic-permission-title-mob">This question requires you to record your answer(s).</h3>
                    <p className="mic-permission-subtitle-mob">Please follow the instructions to enable your microphone permission:</p>
                    
    {
        isIosDevice ?
        (<div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="instruction-tips"><span>1</span>At the top left, click <img src="https://img.icons8.com/fluent-systems-filled/24/000000/sentence-case.png" alt="font"/></div>
                            <div className="instruction-tips"><span>2</span>Select " Website Settings".</div>
                            <div className="instruction-tips"><span>3</span>Tap on "Microphone" and select "Allow"</div>
                        </div>
                    </div> 
                ) :
            ( <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="instruction-tips"><span>1</span>At the top right, click "More options" and go to "Settings".</div>
                            <div className="instruction-tips"><span>2</span>Under "Advanced" click "Site settings"</div>
                            <div className="instruction-tips"><span>3</span>Click Microphone.</div>
                            <div className="instruction-tips"><span>4</span>Turn Ask before accessing on or off.</div>
                        </div>
                    </div> 
                    )
    }
    
                </span>
    )

}

export default PermitMobileInstruction;